/*
 * Add to cart for the whole theme.
 *
 * window.themeCart.add(variantId, quantity, button) is the one place an item
 * goes into the cart: the atc-button snippet below, the product page
 * (main-product.js) and the product cards and quick add (custom.js) all call
 * it. It checks the response — Shopify answers 422 with a description when the
 * stock limit is reached or the variant cannot be bought — and shows the
 * outcome next to the button: the error, or a confirmation with links to the
 * cart and checkout. The header count is refreshed after a successful add.
 *
 * window.themeCart.formatMoney(cents) formats a price in the store's format for
 * the active currency (window.moneyFormat, set in theme.liquid).
 */
(function () {
  var MIN = 1;
  var MAX = 999;
  var strings = window.cartStrings || {};
  var routes = window.routes || {};

  function formatMoney(cents, format) {
    format = format || window.moneyFormat || '{{amount}}';
    var value = (Number(cents) || 0) / 100;

    function withDelimiters(precision, thousands, decimal) {
      var parts = value.toFixed(precision).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      switch (name) {
        case 'amount': return withDelimiters(2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(2, ' ', ',');
        default: return withDelimiters(2, ',', '.');
      }
    });
  }

  function refreshCartCount() {
    return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[js-cart-num]').forEach(function (el) {
          el.innerHTML = cart.item_count;
        });
      })
      .catch(function () { /* the count is cosmetic; ignore */ });
  }

  // One message area per button, placed right after it — on a product card
  // after the quantity and button row, which would otherwise be pushed apart.
  function feedbackFor(button) {
    if (!button) return null;
    var anchor = button.closest('.product-card__form') || button;
    var next = anchor.nextElementSibling;
    if (next && next.classList.contains('atc-feedback')) return next;
    var box = document.createElement('div');
    box.className = 'atc-feedback';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    anchor.insertAdjacentElement('afterend', box);
    return box;
  }

  function showAdded(button) {
    var box = feedbackFor(button);
    if (!box) return;
    var cartUrl = routes.cart_url || '/cart';
    box.className = 'atc-feedback atc-feedback--success';
    box.innerHTML = '';

    var text = document.createElement('span');
    text.textContent = strings.itemAdded || 'Item added to your cart';
    var view = document.createElement('a');
    view.href = cartUrl;
    view.textContent = strings.viewCart || 'View cart';
    // .cart__checkout-button: hidden by cart-country-guard while its bar is active.
    var checkout = document.createElement('a');
    checkout.href = '/checkout';
    checkout.className = 'cart__checkout-button';
    checkout.textContent = strings.checkout || 'Check out';

    box.append(text, view, checkout);
  }

  function showError(button, message) {
    var box = feedbackFor(button);
    if (!box) return;
    box.className = 'atc-feedback atc-feedback--error';
    box.textContent = message || strings.error || 'There was an error while updating your cart. Please try again.';
  }

  function add(variantId, quantity, button) {
    var id = Number(variantId);
    if (!id) return Promise.resolve(null);
    if (button) button.disabled = true;

    return fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: Number(quantity) || 1 })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) {
            // 422: data.description says why ("You can't add more … to the cart.")
            throw new Error(data.description || data.message || '');
          }
          return data;
        });
      })
      .then(function (item) {
        showAdded(button);
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('theme:cart:added', { detail: { item: item } }));
        return item;
      })
      .catch(function (err) {
        showError(button, err && err.message);
        return null;
      })
      .then(function (result) {
        if (button) button.disabled = false;
        return result;
      });
  }

  window.themeCart = { add: add, formatMoney: formatMoney, refreshCount: refreshCartCount };

  /* The atc-button snippet's own controls. Delegated from the document so any
     section can use it, including markup injected after load (product
     recommendations, theme editor re-renders). */
  function qtyInput(group) {
    return group ? group.querySelector('[js-atc-qty]') : null;
  }

  function readQty(group) {
    var input = qtyInput(group);
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < MIN) n = MIN;
    if (n > MAX) n = MAX;
    return n;
  }

  function setQty(group, n) {
    var input = qtyInput(group);
    if (!input) return;
    if (n < MIN) n = MIN;
    if (n > MAX) n = MAX;
    input.value = n;
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[js-atc-minus]');
    var plus = e.target.closest('[js-atc-plus]');
    var button = e.target.closest('[js-atc]');

    if (minus) {
      e.preventDefault();
      var g1 = minus.closest('[js-atc-group]');
      setQty(g1, readQty(g1) - 1);
      return;
    }

    if (plus) {
      e.preventDefault();
      var g2 = plus.closest('[js-atc-group]');
      setQty(g2, readQty(g2) + 1);
      return;
    }

    if (!button || button.disabled) return;
    e.preventDefault();

    var group = button.closest('[js-atc-group]');
    add(button.getAttribute('data-variant-id'), readQty(group), button);
  });

  // keep the field numeric as it is typed
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[js-atc-qty]');
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, '');
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[js-atc-qty]');
    if (!input) return;
    setQty(input.closest('[js-atc-group]'), readQty(input.closest('[js-atc-group]')));
  });
})();
